<template>
  <div class="nrbAboutTraining">
    <section class="section">
      <div class="container">
        <div class="container_1250">
          <div class="about_content about_training">
            <div class="d-flex justify-content-end">
              <u-input2 style="margin-right: 40px; margin-bottom: 20px;" suggest="Search..." @input="search"></u-input2>
            </div>
            <VueFaqAccordion
                :items="myItems"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'
import UInput2 from "@/components/core/UInput2";

export default {
  components: {
    UInput2,
    VueFaqAccordion
  },
  data () {
    return {
      myItems: [
        {
          title: 'What is ‘Upskill Library’?\n',
          value: 'Upskill Library is a one stop platform which will give you access to 34+ live video sessions which can boost and empower your career development.  Unlike other learning platforms, Upskill users only pay once to get access to 140+ hours of learning videos. \n',
          category: 'Upskill Library'
        },
        {
          title: 'Who will be the users?\n',
          value: 'Students and young professionals- both can benefit from using Upskill Library. \n',
          category: 'Upskill Library'
        },
        {
          title: 'Who are the trainers? \n',
          value: 'Sessions are delivered by trained, well experienced and certified instructors in their domain. All our instructors have years of work experience offering practical lessons which users can apply in their job. \n',
          category: 'Upskill Library'
        },
        {
          title: 'How many trainers are there? \n',
          value: 'There are more than 22 trainers’ sessions  available in Upskill Library\n',
          category: 'Upskill Library'
        },
        {
          title: 'How many hours of videos are present? \n',
          value: 'There are 140+ hours of videos available for users to learn from. \n',
          category: 'Upskill Library'
        },
        {
          title: 'How many topics does the Upskill library have?\n',
          value: 'It has more than 34+ live video sessions from software management, data analytics, coding, digital marketing, fund raising, tech business, e-commerce related modules and versatile skill development sessions and many more. After 2 months new content will be added as per the demand for free.',
          category: 'Upskill Library'
        },
        {
          title: 'How will I benefit from this service?\n',
          value: 'At times when potential users cannot attend the online live sessions due to work commitments; Upskill Library offers easy online access to material to learn according to their availability.  \n \n The video library will ensure the users that they don\'t miss anything important; plus, being able to watch the videos, transcribe workshops to review on-screen or organize collection of notes is essential to better learning outcomes. We understand that users prefer to learn in different ways and at different paces, giving them the flexibility and control to view the videos in their own time is an important feature for Upskill Video Library. \n',
          category: 'Upskill Library'
        },
        {
          title: 'Will I get workshop materials?\n',
          value: 'All users will have access to the video lessons only, no other coursework/quiz/study materials will be provided. \n',
          category: 'Upskill Library'
        },
        {
          title: 'What is the price?\n',
          value: 'The annual subscription for Upskill Library starts at Tk.3000 which is equivalnet to Tk.250 per month. However, if you are an existing Upskill user, then you will qualify for a Tk.500 discount when you subscribe to Upskill Library. \n',
          category: 'Upskill Library'
        },
        {
          title: 'Can I share my access with friends and family?\n',
          value: 'No, the link will be sent to only the user who has paid and the link cannot be shared among friends and family members. \n',
          category: 'Upskill Library'
        },
        {
          title: 'Can I ask questions to the trainers? \n',
          value: 'Since the sessions are not live so users cannot ask questions to the trainers. However, you may email us with the name of the session and trainer with your queries. \n',
          category: 'Upskill Library'
        },
        {
          title: 'Is subscribing to Upskill Library worth my time? \n',
          value: 'If you are aiming to develop your skills and enrich your knowledge but have been lagging behind due to academic and work load, then Upskill Library is best suited for you. You can learn at your own pace and availability of time to groom yourself professionally. \n',
          category: 'Upskill Library'
        },
        {
          title: 'Will there be other workshops arranged for the Upskill Library users? \n',
          value: 'All users will continue to receive free access to new video content every 2 months without additional fees. Here versatile topics will be covered from different industries. \n',
          category: 'Upskill Library'
        },
        {
          title: 'Are there any discounts?\n',
          value: 'All past users of Upskill live or offline classes will receive a Tk.500 discount when they subscribe to Upskill Library. \n',
          category: 'Upskill Library'
        },
        {
          title: 'How long is the subscription for?\n',
          value: 'It is a yearly subscription. You will have access to the videos for 12 months\n',
          category: 'Upskill Library'
        },
        {
          title: 'How will I watch the videos?\n',
          value: 'Upskill will give the users a link which will give you access to the session after payment is received. In their profile users can keep track of their learning modules and will be notified of new contents when it is added in the learning platform. \n',
          category: 'Upskill Library'
        },
        {
          title: 'Will I get certification? \n',
          value: 'Unfortunately, we won’t be providing any certification for subscribing to Upskill Library. For enrolling yourself in workshops and sessions where you can get certified, visit- https://upskill.com.bd \n',
          category: 'Upskill Library'
        },
        {
          title: 'What is the minimum class size?\n',
          value: 'For offline workshops, we require minimum 5 participants and for online workshops we recommend minimum 10 participants to make it viable.  \n',
          category: 'Workshops'
        },
        {
          title: 'How Long is a workshop/course?\n',
          value: 'We have several workshop formats which determines the length\n' +
              'Full day offline workshop : 5-6 hours\n' +
              'Online session : 1 - 2 hours max (per session),  including Q&A\n',
          category: 'Workshops'
        },
        {
          title: 'How much is the payment?\n',
          value: 'We offer 30% of the gross revenue. Example: If the price of the workshop is 1000 BDT, the mentor will be paid 300 BDT per every 1000 taka payment.\n' +
              'However, based on the performance of the instructor and demand of the course, Upskill can offer upto 50% (max) revenue share. This is unlocked over time.\n',
          category: 'Workshops'
        },
        {
          title: 'What is the mode of payment?\n',
          value: 'We offer bKash Transfer or Account payee check\n',
          category: 'Workshops'
        },
        {
          title: 'When will I get my payment if I am a mentor\n',
          value: 'We follow a 15 days payment cycle, as all outgoing payments are consolidated. So we pay in the middle of the month and then again at the end of the month. So you will receive payment depending on which cycle you fall into.\n',
          category: 'Workshops'
        },
        {
          title: 'Is it just a lecture based on presentation based?\n',
          value: ' For all lectures, visual aid is mandatory. It can be a PPT or PDF presentation or Screen-sharing while tool specific training like excel or Tableau.\n',
          category: 'Workshops'
        },
        {
          title: 'Should there be assignments?\n',
          value: 'Assignments are a must if it’s a course (more than one session). We have found that to improve engagement and retention of course learning, assignments are great tools for instructors. \n' +
              'We recommend that materials like the presentation deck, some reading materials or reference links, templates if available must be provided after the session. Unless they contain company specific or confidential information. \n',
          category: 'Workshops'
        },
        {
          title: 'Does Upskill Classroom offer support and training to clients?\n',
          value: 'Upskill offers support in your time of need. You can connect with Upskill Classroom experts any time through the call, email, chat etc. To help you in every way, Upskill Classroom experts provide multiple training sessions about software features; training can be arranged over a call or on zoom.\n',
          category: 'Classroom'
        },
        {
          title: 'Will I be bound to any long-term contract?\n',
          value: 'No, you will not be bound to any long-term contract with Upskill as we charge only on an installment basis for the Academic year for our paid features. However, once the payment has been made, you will not be provided with a refund option.\n',
          category: 'Classroom'
        },
        {
          title: 'What happens to the information when the academic year is rolled-over?\n',
          value: 'All the historical data kept at a centralized place, and none of it\'s get deleted. All the relevant users have access to their data, even when the academic year is rolled-over.\n',
          category: 'Classroom'
        },
        {
          title: 'Can I switch from one package to another after using?\n',
          value: 'Yes, you can upgrade your package anytime you would like to. You can get in touch with your Accounts Manager as and when the upgrade is required.\n',
          category: 'Classroom'
        },
        {
          title:'How do I register for a course? \n',
          value:'Under the ‘Workshops’ tab, you can find all the past, present and future workshops. To enroll in an upcoming workshop, click ‘View Workshop’. You can find the ‘Register Now’ button there which enables you to register for the workshop. You should receive an email confirming your registration right away.\n',
          category : 'Upskill Library'

        },
        {
          title :'How do I make my payment online?\n',
          value :'When you register for a workshop online, the ‘Register Now’ button should immediately turn to ‘Pay Online’. If it did not change, please refresh your page. Click the button and follow the steps to make your payment via debit card/credit card or bkash.\n',
          category : 'Upskill Library'
        },
        {
          title:'How do I know that my payment has been accepted? \n',
          value :'After your payment has been made, you should receive an automated email from Upskill, confirming that the payment is received.If you have not received any email from Upskill, but your bank says that the transaction was successful, please call Upskill for reassurance. \n',
            category : 'Upskill Library'

        },
        {
          title: 'How do I get my certificate?',
          value : 'After your workshop has been completed, login to your Upskill account and under the ‘My Profile’ tab, you should see your completed workshops. You’ll find a ‘Feedback’ button beneath your completed workshop. Click the button, fill-in your feedback and submit. Once your feedback is submitted, the button should say ‘Certificate’. If it did not, please refresh the page. Click on it and a new window will open up showing your e-certificate in pdf format. You can now download it from there. \n',
          category : 'Upskill Library'
        },
        {
          title :'How will I have the video recording of the course that I have just completed?',
          value : 'The video recording of the session will be mailed to you within 48 hours from the time when it ended.',
           category : 'Upskill Library'
        }
      ],
      clone: []
    }
  },
  methods: {
    search(e) {
      if (e == "") {
        this.myItems = this.clone
      } else {
        this.myItems = this.clone.filter(o => o.title.includes(e) || o.value.includes(e))
      }
    }
  },
  created() {
    this.clone = this.myItems
  }
}
</script>